<template>
  <v-row>
    <v-col v-if="resume" class="py-0">
      <v-row class="px-5 mb-3">
        <v-col cols="12" class="px-0 py-0">
          <h3 class="headline font-weight-medium mb-3">
            Resumo de Reembolsos Totais
          </h3>
        </v-col>
      </v-row>
      <v-row v-if="resume">
        <v-col class="py-0">
          <material-stats-card
            color="green"
            icon="mdi-cash-refund"
            title="Reembolsos recebidos"
            :value="resume.completed.amount.toReal()"
            sub-text-color="text-normal"
            :subText="`Quantidade de resgates: ${resume.completed.quantity}`"
          />
        </v-col>
        <v-col class="py-0">
          <material-stats-card
            color="orange"
            icon="mdi-cash-register"
            title="Reembolsos à receber"
            :value="resume.pending.amount.toReal()"
            sub-text-color="text-normal"
            :subText="`Quantidade de resgates: ${resume.pending.quantity}`"
          />
        </v-col>
        <v-col
          v-if="resume.pix.amount > 0 && resume.pix.quantity > 0"
          class="py-0"
        >
          <material-stats-card
            color="green"
            icon="mdi-cash-refund"
            title="Reembolsos PIX"
            :value="resume.pix.amount.toReal()"
            sub-text-color="text-normal"
            :subText="`Quantidade de resgates: ${resume.pix.quantity}`"
          />
        </v-col>
        <v-col class="py-0">
          <material-stats-card
            color="#00cec9"
            icon="mdi-cash-multiple"
            title="Valor Total"
            :value="resume.total.amount.toReal()"
            sub-text-color="text-normal"
            :subText="`Quantidade de resgates: ${resume.total.quantity}`"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters("refunds", ["getResume"]),
    resume() {
      return this.getResume;
    }
  },
  created() {
    this.fetchRefundsResume();
  },
  methods: {
    ...mapActions("refunds", ["fetchRefundsResume"])
  }
};
</script>
